import React from 'react';

import { useModalContext } from '~/contexts/modal/ModalContext';
import Discount from '~/modules/cancellation/components/DownsellModal/Discount';

export enum DiscountOffer {
  D_30 = '30%',
  D_50 = '50%',
}

export type InvokeDownsellParams = {
  onSubmit: (productId: string) => Promise<void>;
  onDecline: () => void;
  discountOffer: DiscountOffer;
};

const useDownsell = (): {
  invokeDownsellModal: (params: InvokeDownsellParams) => void;
} => {
  const { handleOpenModal } = useModalContext();

  const invokeDownsellModal = (params: InvokeDownsellParams): void => {
    handleOpenModal({
      maxWidth: '400px',
      disableBackdropClick: true,
      hideCloseButton: true,
      paddingSize: '20px',
      component: ({ onClose }) => (
        <Discount
          onDecline={() => {
            onClose();
            params.onDecline();
          }}
          offer={params.discountOffer}
          onSubmit={params.onSubmit}
        />
      ),
    });
  };

  return { invokeDownsellModal };
};

export default useDownsell;
